<div class="warning" [class.red]="isStrongWarning">
  <h3 class="warning__title" *ngIf="title">
    {{ title }}
  </h3>
  <div class="warning__body">
    <ng-content></ng-content>
  </div>
</div>
